import { Component, input } from '@angular/core';
import { FormRangesParams } from '../../../../../../shared/components/form-with-ranges/form-with-ranges.types';
import {
  AudienceAgeParams,
  AudienceParams
} from '../../../../../types/records-table.types';
import { TabName } from "../../types/edit-audience-modal.types";
import { titlesForAudienceAge } from "../../configs/edit-audience-modal-config";
import { MatTab, MatTabGroup } from "@angular/material/tabs";
import {
  FormWithRangesComponent
} from "../../../../../../shared/components/form-with-ranges/form-with-ranges.component";

@Component({
  selector: 'app-audience-age-card',
  standalone: true,
  imports: [
    MatTabGroup,
    MatTab,
    FormWithRangesComponent
  ],
  templateUrl: './audience-age-card.component.html',
  styleUrl: './audience-age-card.component.scss'
})
export class AudienceAgeCardComponent {
  audienceParams = input.required<AudienceParams>();
  isEditEnabled = input<boolean>(true);

  public prepareFormParamsForAgeTab(tabName: TabName): Array<FormRangesParams> {
    return this.audienceParams().age.map((ageParam: AudienceAgeParams) => {
      return {
        key: ageParam.name,
        name: titlesForAudienceAge[ageParam.name],
        value: ageParam[tabName] ?? 0
      }
    });
  }

  public handleAgeFormRangeChange(formRangeData: Array<FormRangesParams>, tabName: TabName): void {
    this.updateAgeDataAccordingToFormRangeData(formRangeData, tabName);
  }

  private updateAgeDataAccordingToFormRangeData(formRangeData: Array<FormRangesParams>, tabName: TabName): void {
    formRangeData.forEach((formRangeParam: FormRangesParams) => {
      const indexForParamUpdate = this.audienceParams().age.findIndex((param: AudienceAgeParams) => param.name == formRangeParam.key);
      this.audienceParams().age[indexForParamUpdate][tabName] = formRangeParam.value;
    });
  }
}
